import { logger } from '@packages/core-datadog-logging/src/logger';
import { Navigate } from '../types';

const windowNavigate: Navigate = (url, options) => {
  if (options?.state) {
    logger.warn('⚠️ State should not be passed during window-based navigation');
  }

  if (options?.replace) {
    window?.location?.replace(url);
  }
  window?.open(url, options?.target);
};

export { windowNavigate };
